import { NgModule } from '@angular/core';

import { BaseModule } from '../shared/base.module';

import { PaginationModule } from '../shared/pagination/pagination.module';
import { DialogModule } from '../dialog/dialog.module';

// ngx-bootstrap modules
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { ModalModule } from 'ngx-bootstrap/modal';
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {BsDropdownModule} from "ngx-bootstrap/dropdown";
import { MATERIALS } from '../app.materials';
import { BreadcrumbModule } from '../shared/breadcrumb/breadcrumb.module';
import { SelfReportSettingRoutesModule } from './service-provider-setting.routes';
import { CategoriesComponent } from './categories/categories.component';
import { SubCategoriesComponent } from './sub-categories/sub-categories.component';
import { InsurancesComponent } from './insurances/insurances.component';
import { AppAdminSettingHeaderModule } from '../shared/admin-setting/header/header.module';
import { AppAdminSettingActionModule } from '../shared/admin-setting/actions/actions.module';
import { AppAdminSettingSearchModule } from '../shared/admin-setting/search/search.module';
import { ServiceProviderEditModalModule } from '../shared/admin-setting/edit-modal/edit-modal.module';
import { AdminSettingNavigationModule } from '../shared/admin-setting/navigation/navigation.module';
import { CompaniesComponent } from './companies/companies.component';
import { AgeGroupsComponent } from './age-groups/age-groups.component';
import { DomainTextsComponent } from './domain-texts/domain-texts.component';
import { ServiceProvidersComponent } from './service-providers/service-providers.component';
import { ServiceProviderModalComponent } from './service-providers/service-provider-modal/service-provider-modal.component';
import { EditModalHeaderActionModule } from '../shared/admin-setting/edit-modal-header-action/edit-modal-header-action.module';
import { LogosComponent } from './logos/logos.component';

@NgModule({
    imports: [
        MATERIALS,
        BaseModule,
        SelfReportSettingRoutesModule,
        PaginationModule,
        DialogModule,
        ModalModule.forRoot(),
        TooltipModule.forRoot(),
        TypeaheadModule.forRoot(),
        BsDropdownModule.forRoot(),
        AppAdminSettingActionModule,
        AppAdminSettingHeaderModule,
        AppAdminSettingSearchModule,
        AdminSettingNavigationModule,
        ServiceProviderEditModalModule,
        EditModalHeaderActionModule,
        BreadcrumbModule
    ],
    declarations: [
        CategoriesComponent,
        SubCategoriesComponent,
        InsurancesComponent,
        CompaniesComponent,
        AgeGroupsComponent,
        DomainTextsComponent,
        LogosComponent,
        ServiceProvidersComponent,
        ServiceProviderModalComponent
    ]
})

export class ServiveProviderSettingModule { }
